import Tool from './Tool';
import SelectTool from './SelectTool';
import PointSelectTool from './select/PointSelectTool';
import RectSelectTool from './select/RectSelectTool';

export default {
    Tool,
    SelectTool,
    PointSelectTool,
    RectSelectTool
};
